import React from 'react';
import { Typography, Stack } from '@mui/material';
import {
  PayableToField,
  AddressLine1Field,
  AddressLine2Field,
  CityField,
  StateField,
  ZipCodeField,
  CheckNumberField,
  CheckDateField
} from '../fieldEditors/checkInfo';
import { useAppSelector } from '../../../../app/store';
import SectionPaper from '../../../common/components/styled-ui-elements/SectionPaper';

export const CheckInformationSection: React.FC = () => {
  const { currentRefund } = useAppSelector(state => state.refund);
  const isApStatus = currentRefund?.status === 'AP';
  const isPostingStatus = currentRefund?.status === 'POSTING';
  const isCompleteStatus = currentRefund?.status === 'COMPLETE';
  const showCheckFields = isApStatus || isPostingStatus || isCompleteStatus;

  return (
    <SectionPaper>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 2 }}>
        Check Information
      </Typography>
      <Stack spacing={2}>
        {showCheckFields && (
          <Stack direction="row" spacing={2}>
            <CheckNumberField />
            <CheckDateField />
          </Stack>
        )}
        <PayableToField />
        <Stack direction="row" spacing={2}>
          <AddressLine1Field />
          <AddressLine2Field />
        </Stack>
        <Stack direction="row" spacing={2}>
          <CityField />
          <StateField />
          <ZipCodeField />
        </Stack>
      </Stack>
    </SectionPaper>
  );
};

export default CheckInformationSection;
